import React, { useState } from "react";
import "./Contact.css";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaGithub,
  FaLinkedin,
} from "react-icons/fa";

import emailjs from "@emailjs/browser";

const Contact = () => {

  // Store form data
  const [details, setDetails] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");


  // Runs whenever user types
  const handleChange = (e) => {

    setDetails({
      ...details,
      [e.target.name]: e.target.value,
    });

  };


  // Runs when form is submitted
  const handleSubmit = (e) => {

    // Prevent page refresh
    e.preventDefault();

    setStatus("Sending...");


    // Send data to EmailJS
    emailjs
      .send(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        {
          name: details.name,
          email: details.email,
          message: details.message,
        },
        {
          publicKey: "YOUR_PUBLIC_KEY",
        }
      )

      .then(() => {

        setStatus("Message sent successfully! ✅");

        // Clear form
        setDetails({
          name: "",
          email: "",
          message: "",
        });

      })

      .catch((error) => {

        console.log(error);

        setStatus("Failed to send message ❌");

      });
  };


  return (
    <section className="contact">

      <h2>Contact Me</h2>

      <div className="contact-container">

        {/* Contact Information */}

        <div className="contact-info">

          <h3>Let's Connect</h3>

          <p>
            <FaPhoneAlt />
            +91 9347509396
          </p>

          <p>
            <FaEnvelope />
            nagireddyyamuna2003@gmail.com
          </p>

          <p>
            <FaMapMarkerAlt />
            Hyderabad, India
          </p>


          <div className="social-links">

            <a
              href="https://github.com/yamunanagireddy"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub />
            </a>

            <a
              href="https://linkedin.com/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin />
            </a>

          </div>

        </div>


        {/* Form */}

        <form
          className="contact-form"
          onSubmit={handleSubmit}
        >

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={details.name}
            onChange={handleChange}
            required
          />


          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={details.email}
            onChange={handleChange}
            required
          />


          <textarea
            name="message"
            rows="6"
            placeholder="Your Message"
            value={details.message}
            onChange={handleChange}
            required
          ></textarea>


          <button type="submit">
            Send Message
          </button>


          {status && (
            <p className="form-status">
              {status}
            </p>
          )}

        </form>

      </div>

    </section>
  );
};

export default Contact;